module.exports = __webpack_public_path__ + "client/img/s_item_13.a19ed831.png";